import React from 'react';
import { ToolRenderers } from './ToolRenderers';

export function FunctionResults({ functionName, results }: { functionName: string; results: string }) {
    const RenderTool = ToolRenderers[functionName];
    let parsedResults;

    try {
        parsedResults = JSON.parse(results);
    } catch (error) {
        parsedResults = results;
    }

    const formatName = (name: string): string => {
        const functionNameMap: { [key: string]: string } = {
            'get_events_for_day': 'Calendar Event',
            'add_calendar_event': 'Calendar Event',
            'delete_calendar_event': 'Calendar Event',
        };

        if (functionNameMap[name]) {
            return functionNameMap[name];
        }

        return name.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };

    return (
        <div className="function-results">
            <h3 className="function-header">Performed {formatName(functionName)}</h3>
            <div className="results-container">
                {parsedResults == null || parsedResults === "" || typeof(parsedResults) === 'undefined' ? ( // Check for null or false
                    <div className="response-object">
                        <pre>
                            No results available. The input might be invalid or there was an error processing your request.
                        </pre>
                    </div>
                ) : Array.isArray(parsedResults) ? (
                    parsedResults.length === 0 ? (
                        // Handle empty array
                        <div className="response-object">
                            <pre>
                                Could not find any related results. Please rephrase the question or try searching
                                something else.
                            </pre>
                        </div>
                    ) : (
                        parsedResults.map((item, index) => (
                            <div key={index} className="response-object">
                                {RenderTool ? RenderTool(item) : <pre>{JSON.stringify(item, null, 2)}</pre>}
                            </div>
                        ))
                    )
                ) : typeof parsedResults === "object" ? (
                    Object.keys(parsedResults).length === 0 ? (
                        // Handle empty object
                        <div className="response-object">
                            <pre>No results available. The input might be invalid or there was an error processing your request.</pre>
                        </div>
                    ) : (
                        <div className="response-object">
                            {RenderTool ? RenderTool(parsedResults) : <pre>{JSON.stringify(parsedResults, null, 2)}</pre>}
                        </div>
                    )
                ) : (
                    <div className="response-object">
                        {RenderTool ? RenderTool(parsedResults) : <pre>{JSON.stringify(parsedResults, null, 2)}</pre>}
                    </div>
                )}
            </div>
        </div>
    );
};

